var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.model.transferredAmount
        ? _c("text-label-row", {
            attrs: {
              title:
                "Notification.TransferredAmountNotification.TransferredAmount",
              bold: true,
              formatNumber: true,
              sign: "€",
              value: _vm.getStringValue(_vm.model.transferredAmount)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.comments
        ? _c("text-label-row", {
            attrs: {
              title: "Notification.TransferredAmountNotification.Comments",
              bold: true,
              value: _vm.model.comments
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }